<template>
  <page >
    <template :slot="'title'">
      Online <md-icon>videocam</md-icon> / <md-icon>mic</md-icon> Recorder
    </template>
    <template :slot="'content'">
      <div style="text-align: center">
        <h3 class="md-title" v-html="settings.project"></h3>
        <h4 class="md-subtitle" v-if="name" v-html="'Hi ' + name + '!'"></h4>
        <demo v-if="!demo" :onSuccess="setDemo"/>
        <myPassword
          v-if="demo && !pw"
          :password="settings.password"
          :onSuccess="setPassword"
          >Bitte Kennwort eingeben</myPassword>
        <MyName v-if="demo && pw && !name" :onSuccess="setName" />
        <MyRecorder v-if="demo && pw && name" :settings="settings" :name="name" />
      </div>
    </template>
  </page>
</template>
<script>
export default {
  components: {
    page() {
      return import("@/components/page/index.vue");
    },
    MyPassword() {
      return import("@/components/password/index.vue");
    },
    MyName() {
      return import("@/components/name/index.vue");
    },
    MyRecorder() {
      return import("@/components/recorder/index.vue");
    },
    demo() {
      return import("@/components/demo/");
    }
  },
  props: {},
  data() {
    return {
      demo: false,
      settings: false,
      pw: false,
      name: false
    };
  },
  methods: {
    setDemo() {
      this.demo = true
    },
    setName(name) {
      this.name = name;
    },
    setPassword() {
      this.pw = true;
    }
  },
  mounted() {
    this.settings = JSON.parse(atob(this.$route.params.id));
    if (!this.settings.password) {
      this.pw = true;
    }
  },
  computed: {}
};
</script>
<style lang="sass" scoped></style>
